import { FC } from "react";
import { Link } from "react-router-dom";

export const NotFoundPage: FC = () => {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6">
      <div className="text-center">
        <h1 className="text-5xl font-semibold tracking-tight">404</h1>
        <p className="mt-3 text-gray-600">ページが見つかりませんでした。</p>
        <div className="mt-6">
          <Link
            to="/"
            className="inline-block rounded border border-gray-300 px-4 py-2 text-sm hover:bg-gray-50"
          >
            トップへ戻る
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;

